<html>
	<head>
		<title>Data Beer | Centro de control</title>
	</head>
	<body class="loading">
		<div id="wrapper">
			<div id="bg"></div>
			<div id="overlay"></div>
			<div id="main">

				<!-- Header -->
					<header id="header">
						<img class="home-img" src="assets\images\logoHomeSinPnEdited.png">
						<p>Plataforma de monitorización de la cerveza de bodega</p>
						<nav>
							<ul>
								<li><a (click)="enter()" class="icon fa-users"><span class="label">Entrar</span></a></li>
							</ul>
						</nav>
						<div class="btn-login"><span>Entrar</span></div>
					</header>


				<!-- Footer -->
					<footer id="footer">
						<span class="copyright">&copy; Un producto de 
							<a href="https://perfectnumbers.tech/">
							<span class="perfect">Perfect</span>
							<span class="numbers">Numbers</span>
							.
							</a> 
						</span>
					</footer>

			</div>
		</div>
		<!--[if lte IE 8]><script src="{{env('APP_URL')}}/assets/js/ie/respond.min.js"></script><![endif]-->
		<script nonce=cspNonceV>
			window.onload = function() { document.body.className = ''; }
			window.ontouchmove = function() { return false; }
			window.onorientationchange = function() { document.body.scrollTop = 0; }
		</script>
	</body>
</html>
